import { Card, Col, Input, Row, Skeleton, Spin, theme } from 'antd';
import { PropsWithChildren, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RefreshButton from '../RefreshButton';
import TimeDisplay from '../TimeDisplay';

const styles = {
    tooltip: { width: 'max-content' },
    cardBody: { minHeight: 420 },
    chartLoading: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: 420, width: '100%' },
    minWidth: { minWidth: 200 },
    loadingTime: { width: '100%', marginBottom: 0 }
};

interface Props {
    fixedHeight?: boolean;
    loading: boolean;
    onButtonClick?: (...args: any) => any | Promise<any>;
    title: string;
    updateTime: number;
    agentSearchable?: { setSearchTerm: (value: string) => void } | null;
}

export default function ReportCard({
    children,
    fixedHeight = false,
    loading,
    onButtonClick,
    title,
    updateTime,
    agentSearchable = null
}: PropsWithChildren<Props>) {
    const {
        token: { fontSize, fontSizeSM }
    } = theme.useToken();
    const { t } = useTranslation('dashboard');
    const bodyStyle = {
        ...styles.minWidth,
        ...(fixedHeight ? styles.cardBody : {})
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { height, ...rest } = styles.chartLoading;
    const loadingChartStyle = fixedHeight ? styles.chartLoading : rest;
    const [searchTerm, setSearchTerm] = useState<string>('');
    return (
        <Card
            actions={
                updateTime
                    ? [
                          <TimeDisplay
                              key={updateTime}
                              textProps={{ style: { fontSize: fontSizeSM - 1 } }}
                              time={updateTime}
                          />
                      ]
                    : loading
                    ? [
                          <Skeleton
                              key={1}
                              title={{ style: styles.loadingTime }}
                              paragraph={{ style: { display: 'none' } }}
                              active
                              loading
                          />
                      ]
                    : []
            }
            bodyStyle={bodyStyle}
            className="chart-card"
            extra={<RefreshButton onRefreshButtonClick={onButtonClick} />}
            headStyle={{ fontSize, textAlign: 'center' }}
            size="small"
            title={
                agentSearchable ? (
                    <Row justify="space-around" align="middle">
                        <Col span={6}>
                            <Input.Search
                                allowClear
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    if (e.target.value === '') agentSearchable?.setSearchTerm('');
                                }}
                                placeholder={t('searchAgentByNamePlaceholder')}
                                onSearch={() => agentSearchable?.setSearchTerm(searchTerm)}
                            />
                        </Col>
                        <Col span={12}>{title}</Col>
                        <Col span={6}></Col>
                    </Row>
                ) : (
                    title
                )
            }
        >
            {loading ? (
                <div style={loadingChartStyle}>
                    <Spin />
                </div>
            ) : (
                children
            )}
        </Card>
    );
}
